import {useEffect,useState} from 'react';
import {useLocation} from 'react-router';
import {Permissions as P} from '@myfm/domain';
import {api} from '../api';
import {useAuth} from '../auth';
import {useCapability} from './StaffSession';
import {buildingOnboardingProgress,createOnboardingSummaryReader,onboardingSummaryBuilding,onboardingSummaryPath} from './building-onboarding-progress';
import {guidedBuildingSetup} from '@myfm/domain';
import {useBuildingReadiness} from './BuildingReadiness';
import {onboardingJourneyHref} from './building-onboarding-progress';

/** One shared summary read per building; any successful save (api.ts dispatches 'canonical-record-saved') marks it stale for the Overview card. */
const summaries=createOnboardingSummaryReader(building=>api<unknown>(onboardingSummaryPath(building)));
if(typeof window!=='undefined')window.addEventListener('canonical-record-saved',()=>summaries.clear());
/** Incomplete onboarding, including already-managed buildings; permission and summary checks still apply. */
export function useBuildingOnboardingProgress(building:string|undefined,current=false){
 const target=onboardingSummaryBuilding(building,useCapability(P.ViewClientOnboarding)),{config}=useAuth(),{pathname}=useLocation();
 const readiness=useBuildingReadiness();
 const[state,setState]=useState<{building:string;rows:unknown}>();
 useEffect(()=>{
  if(!target||config?.buildingOnboardingEnabled)return;let current=true;
  summaries.read(target,current).then(rows=>{if(current)setState({building:target,rows})},()=>{if(current)setState({building:target,rows:undefined})});
  return()=>{current=false};
 },[target,pathname,current,config?.buildingOnboardingEnabled]);
 if(config?.buildingOnboardingEnabled){
  if(!target||readiness.data?.building.id!==target)return undefined;
  const model=readiness.data,summary=guidedBuildingSetup(model).readiness;
  if(!summary.total||summary.completed===summary.total)return undefined;
  return {building:target,completed:summary.completed,total:summary.total,blocked:summary.essential,goLive:model.goLiveDate??null,href:onboardingJourneyHref(target,true),managementLive:model.managementStatus==='Live'};
 }
 return target&&state?.building===target?buildingOnboardingProgress(state.rows,target,Boolean(config?.buildingOnboardingEnabled)):undefined;
}
